import { Link } from "react-router-dom";
import PageHero from "../components/PageHero";

const newsItems = [
  {
    title: "eSgEA - Training Platform and Chatbot",
    image: "/images/projects/esgea.png",
    description:
        "Discover the eSgEA training platform and AI-powered chatbot, supporting ESG awareness, learning, workplace feedback and practical sustainability action in the shipping industry.",
    link: "/esgea-platform-and-chatbot",
    buttonText: "Read more",
  },
  {
    title: "She4Sea Multiplier Events",
    image: "/images/news/she4sea/she4sea-logo.jpg",
    description:
      "Check out the Multiplier Events for the European project She4Sea, showcasing dissemination activities, stakeholder engagement and piloting actions across Europe.",
    link: "/she4sea-multiplier-events",
    buttonText: "Read more",
  },
  {
    title: "She4Sea Profiling Tool",
    image: "/images/news/she4sea/she4sea-logo.jpg",
    description:
        "Explore the She4Sea Profiling Tool, designed to help women map their skills, discover career potential and identify suitable pathways across maritime, aquaculture and tourism sectors.",
    link: "/she4sea-profiling-tool",
    buttonText: "Read more",
  },
];

function News() {
  return (
    <>
      <PageHero
        eyebrow="News"
        title="Latest updates from our projects"
        text="Explore selected news, activities and digital outputs from European projects supported by R&Do."
      />

      <section className="section news-section">
        <div className="news-grid">
          {newsItems.map((item) => (
            <article className="news-card" key={item.title}>
              <div className="news-card-image">
                <img src={item.image} alt={item.title} />
              </div>

              <div className="news-card-content">
                <span className="eyebrow">Project News</span>
                <h2>{item.title}</h2>
                <p>{item.description}</p>

                {item.disabled ? (
                  <span className="btn secondary disabled-btn">{item.buttonText}</span>
                ) : (
                  <Link to={item.link} className="btn primary">
                    {item.buttonText}
                  </Link>
                )}
              </div>
            </article>
          ))}
        </div>
      </section>
    </>
  );
}

export default News;